var _path, _circle, _path2, _circle2, _path3, _circle3, _circle4, _path4, _rect, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEncryptioninline = function SvgEncryptioninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M17.5 40h9M26.5 32h-12V21"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    fill: "#D6FFFC",
    stroke: "#00877C",
    strokeWidth: 2,
    transform: "matrix(1 0 0 -1 14.5 19)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M26.5 48h-12v11"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    fill: "#FBDADA",
    stroke: "#EB4748",
    strokeWidth: 2,
    transform: "matrix(1 0 0 -1 14.5 61)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D1D7E0",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M53.5 40h10M53.5 32h12V21M53.5 48h12v11"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    fill: "#FBDADA",
    stroke: "#EB4748",
    strokeWidth: 2,
    transform: "matrix(1 0 0 -1 65.5 19)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 5,
    fill: "#FFF5D6",
    stroke: "#FFBF00",
    strokeWidth: 2,
    transform: "matrix(1 0 0 -1 65.5 61)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0080FF",
    strokeWidth: 2,
    d: "M32.5 21.5a7.5 7.5 0 0 1 15 0V27h-15z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 26,
    x: 26.5,
    y: 27,
    fill: "#D6EBFF",
    stroke: "#0080FF",
    strokeWidth: 2,
    rx: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0080FF",
    fillRule: "evenodd",
    d: "M39.996 35a1.5 1.5 0 0 0-1.5 1.5V39.91c-.894.472-1.496 1.352-1.496 2.36 0 1.507 1.343 2.728 3 2.728s3-1.221 3-2.727c0-1.012-.605-1.894-1.505-2.365l.001-.042V36.5a1.5 1.5 0 0 0-1.5-1.5",
    clipRule: "evenodd"
  })));
};
export default SvgEncryptioninline;